module.exports = __webpack_public_path__ + "img/Z85-X18-中_14.1cdbd0ae.jpg";